module.exports = __webpack_public_path__ + "static/nodejs-hexagonal-architecture-dc88096d2edb4c6dff35c8187e9d07bf.png";